<template>
  <div class="health-data-collection">
    <!-- 头部 -->
    <!-- <HeaderModel></HeaderModel> -->
    <!-- 返回按钮 -->
    <div class="back-home" @click="goBack">
      <img
        class="back-icon"
        src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login3.png"
        alt=""
      />
      <span>返回首页</span>
    </div>

    <!-- 页面标题 -->
    <h1 class="page-title">健康数据采集</h1>
    <p class="page-subtitle">HEALTH DATA COLLECTION</p>

    <!-- 主要内容卡片 -->
    <div class="content-card">
      <!-- 准备采集 -->
      <div class="section">
        <div class="section-header">
          <img
            class="section-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11caiji1.png"
            alt=""
          />
          <h2 class="section-title">准备采集</h2>
        </div>
        <p class="section-desc">请允许访问您的摄像头以开始采集生物数据</p>
      </div>

      <!-- 分割线 -->
      <div class="divider"></div>

      <!-- 采集环境建议 -->
      <div class="section">
        <h2 class="section-title">采集环境建议</h2>
        <p class="section-desc gray-text">
          为确保数据准确，建议您在以下环境中测量：
        </p>

        <div class="tips-list">
          <div class="tip-item">
            <span class="tip-label">光线充足：</span>
            <span class="tip-content">面向光源，避免背光</span>
          </div>
          <div class="tip-item">
            <span class="tip-label">面部清晰：</span>
            <span class="tip-content">请勿遮挡面部，摘下眼镜（如佩戴）</span>
          </div>
          <div class="tip-item">
            <span class="tip-label">距离适中：</span>
            <span class="tip-content"
              >保持手机/电脑距面部约一臂距离（30-60厘米）</span
            >
          </div>
          <div class="tip-item">
            <span class="tip-label">保持放松：</span>
            <span class="tip-content">自然呼吸，避免说话或移动</span>
          </div>
        </div>
      </div>

      <!-- 开始按钮 -->
      <button class="start-btn" @click="handleStart">
        <img
          class="play-icon"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11caiji2.png"
          alt=""
        />
        <span>开始30秒健康扫描</span>
      </button>
    </div>
    <!-- 摄像头禁止弹窗 -->
    <!--  -->
    <!-- 页脚 -->
    <FooterModel
      style="position: absolute; bottom: 0; left: 0; right: 0"
    ></FooterModel>
  </div>
</template>

<script>
import { create } from "@/api/index";
import HeaderModel from "@/components/HeaderModel.vue";
import FooterModel from "@/components/FooterModel.vue";
export default {
  name: "CollectModel",
  components: {
    FooterModel,
    HeaderModel,
  },
  data() {
    return {};
  },
  methods: {
    goBack() {
      this.$router.replace("/");
    },

    // 请求唤醒锁（禁止息屏）
    async requestWakeLock() {
      if (!("wakeLock" in navigator)) return;
      try {
        this.wakeLock = await navigator.wakeLock.request("screen");
        console.log("✅ 已禁止息屏");
      } catch (err) {
        console.warn("❌ 禁止息屏失败", err);
      }
    },

    // 释放唤醒锁（恢复息屏）
    releaseWakeLock() {
      document.exitFullscreen()
      if (this.wakeLock) {
        this.wakeLock.release();
        this.wakeLock = null;
        console.log("🔓 已恢复息屏");
      }
    },
    /**
     * 开始按钮点击处理
     */
    async handleStart() {
      this.requestWakeLock();
      if (localStorage.getItem('mode')) {
        this.$emit("handleStart");
        return
      }
      try {
        await create({}).then((res) => {
          localStorage.setItem('id', res.id)
          this.$emit("handleStart");
        });
      } catch (err) {
        this.$toast.error("接口调用失败，请稍后重试");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .health-data-collection {
    min-height: 100vh;
    padding-bottom: 10rem;
    position: relative;
    width: 100%;
    background: linear-gradient(73deg, #e8f2ff 0%, #ffffff 50%, #f4f1ff 100%);
    // padding: 3.75rem 1.25rem;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      sans-serif;

    .back-home {
      width: 68.75rem;
      padding-top: 3.75rem;
      margin: auto;
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
      color: #4e5361;
      font-size: 1.25rem;
      font-weight: 500;
      cursor: pointer;
      user-select: none;

      .back-icon {
        width: 1.625rem;
        height: 1.625rem;
        margin-right: 1.1rem;
      }
    }

    .page-title {
      font-weight: bold;
      font-size: 3rem;
      color: #101424;
      text-align: center;
      margin-bottom: 1rem;
    }

    .page-subtitle {
      font-size: 1rem;
      color: #666;
      text-align: center;
      margin-bottom: 2rem;
      letter-spacing: 0.5px;
    }

    .content-card {
      width: 68.75rem;
      height: 38rem;
      margin: 0 auto;
      // margin-bottom: 18rem;
      background: #fff;
      border-radius: 1.4rem;
      padding: 4rem 6rem;
      box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(0, 116, 252, 0.2);
      box-sizing: border-box;

      .section {
        margin-bottom: 2rem;

        .section-header {
          display: flex;
          align-items: center;
          margin-bottom: 0.75rem;

          .section-icon {
            width: 1.5rem;
            height: 1.5rem;
            margin-right: 0.75rem;
          }

          .section-title {
            font-size: 1.25rem;
            font-weight: 600;
            color: #101424;
            margin: 0;
          }
        }

        .section-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #101424;
          margin-bottom: 0.75rem;
        }

        .section-desc {
          font-size: 0.9375rem;
          color: #4e5361;
          line-height: 1.6;
          margin: 0;
        }

        .gray-text {
          color: #999;
        }
      }

      .divider {
        height: 1px;
        background: #f0f0f0;
        margin: 2rem 0;
      }

      .tips-list {
        margin-top: 1.5rem;

        .tip-item {
          display: flex;
          margin-bottom: 1rem;
          line-height: 1.6;

          .tip-label {
            font-weight: 500;
            color: #101424;
            flex-shrink: 0;
            margin-right: 0.25rem;
          }

          .tip-content {
            color: #4e5361;
          }
        }
      }

      .start-btn {
        width: 100%;
        height: 3.875rem;
        background: #0074fc;
        border: none;
        border-radius: 0.75rem;
        color: #fff;
        font-size: 1.5rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 1rem;

        .play-icon {
          width: 1.5rem;
          height: 1.5rem;
          margin-right: 0.75rem;
        }

        &:hover {
          background: #0066e0;
        }

        &:active {
          background: #0058c0;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .health-data-collection {
    background: linear-gradient(160deg, #e8f2ff 0%, #ffffff 45%, #f4f1ff 100%);
    min-height: 100vh;
    width: 100%;
    overflow-y: auto;
    padding-bottom: 14rem;
    // padding: 4rem 0 16rem; /* 顶部留白，底部为固定页脚预留空间 */
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, sans-serif;
    position: relative;
  }

  /* 返回首页链接（与登录页 .back-home 完全一致） */
  .back-home {
    width: 42.375rem;
    margin: 0 auto 4rem;
    padding-top: 4rem;
    display: flex;
    align-items: center;
    color: #4e5361;
    font-weight: 600;
    font-size: 1.75rem;
    cursor: pointer;
    user-select: none;

    .back-icon {
      width: 2.25rem;
      height: 2.25rem;
      margin-right: 1.1rem;
      object-fit: contain;
    }
  }

  /* 主标题 */
  .page-title {
    width: 42.375rem;
    margin: 0 auto 0.5rem; /* 与副标题间距较小 */
    font-weight: bold;
    font-size: 3rem;
    color: #101424;
    text-align: center;
  }

  /* 副标题 */
  .page-subtitle {
    width: 42.375rem;
    margin: 0 auto 3rem;
    font-size: 1.2rem;
    color: #9fa1a8;
    text-align: center;
    letter-spacing: 0.1rem;
    font-weight: 400;
  }

  /* 内容卡片（与登录页 .login-form 一致） */
  .content-card {
    width: 42.375rem;
    margin: 0 auto;
    margin-bottom: 8rem;
    padding: 3rem 2.25rem;
    background: #ffffff;
    border-radius: 1.5rem;
    box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 116, 252, 0.2);
    box-sizing: border-box;
  }

  /* 分区通用样式 */
  .section {
    margin-bottom: 2.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
  .section-title {
    font-size: 2rem;
    font-weight: bold;
    color: #101424ff;
    margin: 0;
  }
  /* 分区头部（图标+标题） */
  .section-header {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 1rem;

    .section-icon {
      width: 3rem;
      height: 3rem;
      object-fit: contain;
      flex-shrink: 0;
    }

    .section-title {
      font-size: 2.25rem;
      font-weight: 600;
      color: #101424;
      margin: 0;
    }
  }

  /* 分区描述（通用） */
  .section-desc {
    font-size: 1.75rem;
    color: #10142480;
    line-height: 1.5;
    margin: 0;

    &.gray-text {
      color: #9fa1a8;
      font-size: 1.5rem;
      margin-bottom: 1.5rem;
    }
  }

  /* 分割线 */
  .divider {
    height: 1px;
    background: #e5e7eb;
    margin: 2rem 0;
    width: 100%;
  }

  /* 提示列表 */
  .tips-list {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }

  .tip-item {
    display: flex;
    align-items: flex-start;
    font-size: 1.75rem;
    line-height: 1.75;
    color: #333;
    font-weight: 400;

    .tip-label {
      color: #101424ff;
      min-width: 7rem; /* 保证标签对齐 */
      flex-shrink: 0;
    }

    .tip-content {
      flex: 1;
      color: #101424ff;
    }
  }

  /* 开始按钮（包含图标和文字） */
  .start-btn {
    width: 100%;
    height: 6.5rem;
    background-color: #1677ff;
    color: #ffffff;
    font-weight: 500;
    font-size: 2.25rem;
    text-align: center;
    border: none;
    border-radius: 1.5rem;
    cursor: pointer;
    transition: background-color 0.2s;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-top: 2rem;

    &:hover {
      background-color: #4096ff;
    }

    .play-icon {
      width: 2.5rem;
      height: 2.5rem;
      object-fit: contain;
    }
  }
}
</style>